import { CountUp } from './vendor/_countup'

const themeSetupCounters = function() {

  const counters = document.querySelectorAll( '.is-style-stat-counter mark' )

  if ( counters ) {

    // Setup the counters
    counters.forEach( counter => {
      counter.setAttribute( 'data-target', counter.innerText.replaceAll( ',', '' ) )
      counter.innerText = ''
    })
  
    counters.forEach( counter => {

      const countup = new CountUp( counter, counter.getAttribute('data-target'), {
        enableScrollSpy: true,
        scrollSpyOnce: true,
        duration: 2
      } );

      if ( !countup.error ) countup.start()

    } )

  }

}

themeSetupCounters()